/**
 * 授权配置
 * @author chenliying
 */
const Config = {
    /**
     * appid配置
     */ 
    upInfoInPlatform: {
        // 微信平台
        'wechat': {
            appid: 'wx78a12cd5f3b2a993',
            appid_stage: 'wx78a12cd5f3b2a993'
        },
        'wechatQrcode': {
            appId: 'wxbe95819b0e7499a9',
            appSecret: 'b34144895076ee00a3c2dd5c9bb2f3cb'
        },
        // fb平台
        'fb': {
            appid: '1698316857098420'
        },
        // 微博
        'weibo': {
            appid: '3739970591'
        },
        google: {
            clientId: '810710132118-nhlomv7vpqsm6v2a0c9lsgkhbpd4c2qo.apps.googleusercontent.com'
        }
    }
};

export default Config;


// WEBPACK FOOTER //
// ./src/js/openjs/deps/login/config.js